import { render, staticRenderFns } from "./MenuVuetify.vue?vue&type=template&id=6c7ef451"
import script from "./MenuVuetify.vue?vue&type=script&lang=js"
export * from "./MenuVuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports